import { initAll, track, setUserId, reset } from '@amplitude/unified'

const apiKey = import.meta.env.VITE_AMPLITUDE_API_KEY as string | undefined
const env = (import.meta.env.VITE_ENV as string | undefined) ?? 'development'

export function initAnalytics(): void {
  if (!apiKey) return
  initAll(apiKey, {
    serverZone: 'EU',
    instanceName: `vaultbi-${env}`,
    analytics: {
      autocapture: true,
    },
    sessionReplay: {
      sampleRate: 1,
    },
  })
}

export function identifyUser(email: string): void {
  if (!apiKey) return
  try { setUserId(email) } catch { /* non-blocking */ }
}

export function resetAnalytics(): void {
  if (!apiKey) return
  try { reset() } catch { /* non-blocking */ }
}

export function trackEvent(name: string, properties?: Record<string, unknown>): void {
  if (!apiKey) return
  try { track(name, properties) } catch { /* non-blocking */ }
}
